export function readCookie(name: string): string | null {
  const cookies = globalThis.document?.cookie ?? '';
  if (!cookies) return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = cookies.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function writeCookie(name: string, value: string, days = 365): void {
  if (!globalThis.document) return;
  const expires = new Date();
  expires.setDate(expires.getDate() + days);
  const isSecure = globalThis.location?.protocol === 'https:';
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    'path=/',
    `expires=${expires.toUTCString()}`,
    'SameSite=Lax',
  ];
  if (isSecure) parts.push('Secure');
  globalThis.document.cookie = parts.join('; ');
}

export function deleteCookie(name: string): void {
  if (!globalThis.document) return;
  globalThis.document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
